module.exports = __webpack_public_path__ + "img/select-right.a052118c.svg";